<script setup lang="ts">
const props = defineProps<{
  category: PublicKBCategory
  article?: PublicKBArticle
}>()

const routes = useRoutes()

const items = [
  { label: "Home", path: routes.root_path() },
  { label: props.category.title, path: props.category.path },
]

if (props.article) {
  items.push({ label: props.article.title, path: props.article.path })
}
</script>

<template>
  <PrimeBreadcrumb :model="items" class="max-w-full p-0 py-2">
    <template #item="{ item }">
      <InertiaLink :href="item.path" class="whitespace-nowrap text-gray-500 hover:text-gray-700">
        {{ item.label }}
      </InertiaLink>
    </template>
  </PrimeBreadcrumb>
</template>
